import EntityServise from "./entityService";

class EntityFieldCustomService extends EntityServise {
    constructor() {
        super("entityFieldCustom")
    }

    async getByEntityName(name) {
        return await this.http.get(`${this.routeApi}/entity`, { name });
    }

}

export default new EntityFieldCustomService();